import Brand from "../../../model/brand/Brand";
import * as React from "react";
import {Fragment} from "react";
import PageHeaderView from "../../body/PageHeaderView";
import PageContentView from "../../body/PageContentView";
import {RootState} from "../../../store/reducer/root/RootState";
import {Option} from "ts-option";
import {connect} from "react-redux";
import BrandsTable from "./BrandsTable";
import BrandListEmptyView from "./BrandListEmptyView";
import Organization from "../../../model/organization/Organization";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import Spinner from "../../../hiberUiKit/src/atoms/Spinner/Spinner";
import Routes from "../../../navigation/route/Route";
import {RouteComponentProps, withRouter} from "react-router";

const spinner = require("./../../../../resources/hiber/img/spinner-orange.png");

interface ReduxProps {
	/**
	 * All brands.
	 */
	brands: Option<Brand[]>;
	/**
	 * Organization data.
	 */
	organization: Option<Organization>;
}

type Props = ReduxProps & RouteComponentProps<{}>

class BrandList extends React.PureComponent<Props, {}> {
	render() {
		if (this.props.brands.isEmpty) {
			return (
				<Spinner imgUrl={spinner} size={72}/>
			);
		}
		else if (this.props.brands.get.length) {
			return (
				<Fragment>
					<PageHeaderView header={"Brands"}>
						<ButtonPrimary onClick={() => this.props.history.push(Routes.BrandCreate)}
									   label={"Create Brand"}
									   variant={"burgundy"}/>
					</PageHeaderView>
					<PageContentView>
						<BrandsTable brands={this.props.brands.getOrElse([])}
									 organization={this.props.organization}
									 onRowClick={(brand) => this.props.history.push(Routes.BrandEdit(brand.id))}/>
					</PageContentView>
				</Fragment>
			);
		}
		else {
			return <BrandListEmptyView/>
		}
	}
}

function mapStateToProps(state: RootState) {
	return {
		brands: state.brand.brands,
		organization: state.organization.organization
	}
}

export default withRouter(connect(mapStateToProps)(BrandList));